"use client"

import styled, { css } from "styled-components"

import { Button } from "@/components/Button"
import { ContentContainer as BaseContentContainer } from "@/containers/ContentLayout/styled"

export const ModalBackground = styled.div`
  ${({ theme }) => {
    const { colors, zIndex } = theme

    return css`
      display: flex;
      position: fixed;
      inset: 0;
      z-index: ${zIndex.backdrop};
      background-color: ${colors.modal.bg};
      align-items: center;
      justify-content: center;
    `
  }}
`

export const ModalContent = styled.div`
  ${({ theme, $size, $maxWidth }) => {
    const { borders, colors, spaces, widgets, zIndex } = theme

    return css`
      position: relative;
      display: flex;
      flex-direction: column;
      gap: ${spaces.normal};
      padding: ${spaces.large};
      width: ${widgets.modal[$size].width};
      max-width: ${$maxWidth ? $maxWidth : widgets.modal[$size].maxWidth};
      max-height: 100vh;
      overflow-y: auto;
      background-color: ${colors.standard.bg};
      border-radius: ${borders.radius.standard};
      z-index: ${zIndex.overlay};
    `
  }}
`

export const Header = styled.header`
  ${({ theme }) => {
    const { small, normal, large } = theme.spaces
    return css`
      padding: 0 calc(${large} + ${normal}) 0 ${small};
    `
  }}
`

export const Title = styled.h2`
  ${({ theme }) => {
    const { fonts } = theme

    return css`
      margin: unset;
      font-size: ${fonts.size.heading2};
      font-weight: ${fonts.weight.regular};
    `
  }}
`

export const CloseButton = styled(Button)`
  ${({ theme }) => {
    const { spaces } = theme

    return css`
      position: absolute;
      top: ${spaces.large};
      right: ${spaces.large};
    `
  }}
`

export const ContentContainer = styled(BaseContentContainer)`
  ${({ theme }) => {
    const { small, large } = theme.spaces
    return css`
      padding: ${small} ${large};
    `
  }}
`
